import { TaxSectionProps } from ".";
import { Rewind } from "../../styles/icons/Rewind";
import { UpdateHistoryIcon } from "../../styles/icons/UpdateHistoryIcon";
import { Flex, Text } from "../Sellers/styles";
import { Button, Header, Section, UpdateHistoryBlock, UpdateHistoryItem } from "./styles";
import { FullSellerRatesHistory, SellerRatesHistoryPaginatorDataContent } from "../../models/Rates";
import { format } from "date-fns";

interface UpdateHistorySectionProps extends TaxSectionProps {
  sellerRatesHistory: SellerRatesHistoryPaginatorDataContent;
  handleGetSellerRatesHistory: () => void;
  handleGetFullSellerRatesHistory: (id: string) => void;
  fullHistoryResponse: FullSellerRatesHistory;
  openModal: () => void;
}

export function UpdateHistorySection({
  editionMode = false,
  sellerRatesHistory,
  handleGetSellerRatesHistory,
  handleGetFullSellerRatesHistory,
  fullHistoryResponse,
  openModal
}: UpdateHistorySectionProps) {
  function handleOpenHistoryModal(id: string) {
    handleGetFullSellerRatesHistory(id);
    openModal();
  }
  return (
    <>
      <Section flexDir="column" disabled={editionMode}>
        <Section gap=".4rem">
          <UpdateHistoryIcon />
          <Header>Histórico de alterações</Header>
        </Section>
        <UpdateHistoryBlock>
          {sellerRatesHistory?.content?.map(item => (
            <UpdateHistoryItem key={item?.id} disabled={editionMode}>
              <Text fontSize="12px" color="var(--gray-400)">
                {format(new Date(item?.createAt), "dd/MM/yyyy")} - {format(new Date(item?.createAt), "h'h'mm")} - {item?.createBy}
              </Text>
              <Text fontSize="14px" color={editionMode ? "var(--gray-300)" : "#000000D9"}>
                {item?.observation}
              </Text>
              <Button
                disabled={editionMode}
                padding="0"
                bgColor="transparent"
                onClick={() => handleOpenHistoryModal(item?.id)}
              >
                <Flex gap=".5rem">
                  <Rewind color={editionMode ? "var(--gray-300)" : "var(--blue-600)"} />
                  <Text color={editionMode ? "var(--gray-300)" : "var(--blue-600)"} fontSize=".9rem">
                    Ver alterações
                  </Text>
                </Flex>
              </Button>
            </UpdateHistoryItem>
          ))}
          {sellerRatesHistory?.totalElements > sellerRatesHistory?.content?.length && (
            <Button
              disabled={editionMode}
              padding="0"
              bgColor="transparent"
              color="#000000D9"
              onClick={handleGetSellerRatesHistory}
            >
              + Ver mais
            </Button>
          )}
        </UpdateHistoryBlock>
      </Section>
    </>
  )
}